import React from 'react';
import { shortDate } from './sncShared';

/**
 * 409 ROW_CONFLICT on a decision save (spec §8.1): someone else saved this row
 * after it was loaded here. Replace re-sends this page's choice against their
 * row version; Cancel reloads the list so their choice is shown.
 */
const whoOf = (decidedBy) => {
  if (!decidedBy) return 'Someone';
  if (typeof decidedBy === 'string') return decidedBy;
  return decidedBy.name || 'Someone';
};

const choiceOf = (current) => {
  if (current.action === 'link') return current.targetName || 'a dish';
  if (current.action === 'add') return 'Add new';
  if (current.action === 'skip') return 'Skip';
  return null;
};

export default function ConflictModal({ name, current, busy, onReplace, onCancel }) {
  const cur = current || {};
  const who = whoOf(cur.decidedBy);
  const when = cur.decidedAt ? ` on ${shortDate(cur.decidedAt)}` : '';
  const choice = choiceOf(cur);
  const sentence = choice
    ? `${who} already set this to ${choice}${when}. Replace?`
    : `${who} already cleared this${when}. Replace?`;

  return (
    <div className="snc-modal-overlay" role="presentation">
      <div className="snc-modal" role="dialog" aria-modal="true" aria-labelledby="snc-conflict-title">
        <h3 id="snc-conflict-title" className="snc-modal__title">“{name}” was changed</h3>
        <p className="snc-modal__text">{sentence}</p>
        <div className="snc-modal__actions">
          <button type="button" className="snc-btn snc-btn--outline" onClick={onCancel} disabled={busy}>Cancel</button>
          <button type="button" className="snc-btn snc-btn--primary" onClick={onReplace} disabled={busy}>
            {busy ? 'Saving…' : 'Replace'}
          </button>
        </div>
      </div>
    </div>
  );
}
